import React, { PropTypes } from 'react';
import playable from '@alias/Playable';

const ScheduleLink = ({
  clickHandler,
  listing,
  name = '',
  playerHref,
  userIsBlackedOut,
  blackoutClickHandler,
  blackoutMessage
}) => {
    let blackoutLink;
    if (userIsBlackedOut) {
        blackoutLink = (
            <p style={{ display: 'inline' }}>&nbsp;|&nbsp;<a onClick={blackoutClickHandler}>{blackoutMessage}</a></p>
        );
    }

    return (listing.type === 'upcoming') ?
        <div>{name}{blackoutLink}</div> :
        <div><a href={playerHref} data-route="false" onClick={clickHandler}>{name}</a>{blackoutLink}</div>;
};

ScheduleLink.propTypes = {
    clickHandler: PropTypes.func,
    blackoutClickHandler: PropTypes.func,
    listing: PropTypes.object,
    playerHref: PropTypes.string,
    name: PropTypes.string,
    userIsBlackedOut: PropTypes.bool,
    blackoutMessage: PropTypes.string
};

export default playable(ScheduleLink);
export { ScheduleLink as BaseScheduleLink };



// WEBPACK FOOTER //
// ./app/common/schedule/ScheduleLink.js